import { Descriptions, Divider } from "antd";
import { selectCurrentBusiness } from "../../../businessesSlice";
import { useAppSelector } from "../../../../../app/hooks";
import { MissingTag } from "../BusinessDetailsModal";

export default function BusinessPartnerInfo() {
  const currentBusiness = useAppSelector(selectCurrentBusiness);

  return (
    <>
      {currentBusiness?.partnerId ? (
        <>
          <Descriptions
            title="Partner Details"
            labelStyle={{ opacity: 0.6, width: "130px" }}
          >
            <Descriptions.Item label={"Partner Name"}>
              {currentBusiness?.partnership}
            </Descriptions.Item>
            <Descriptions.Item label={"Purchase Price Profile Id"}>
              {currentBusiness.partnerPurchPriceProfileId}
            </Descriptions.Item>
          </Descriptions>
        </>
      ) : (
        "No partner information available"
      )}
    </>
  );
}
